import { createAction } from "@reduxjs/toolkit";

export const deleteRecipeAction = createAction<string>("deleteRecipe");

export const deleteCollectionAction = createAction<string>("deleteCollection");

// Soft-delete a shopping list; the items slice cascades its items off the same
// action (mirrors the collection → recipeCollections cascade).
export const deleteShoppingListAction = createAction<string>("deleteShoppingList");

// Merge lists into one: the items slice re-parents every item on `fromIds` to
// `intoId`; the lists slice soft-deletes the `fromIds` lists. Used to reconcile
// duplicate primary lists that a pre-deterministic-id install could create across
// devices.
export const mergeShoppingListsAction = createAction<{
  fromIds: string[];
  intoId: string;
}>("mergeShoppingLists");

// Resets every slice to its initial state (used on user switch). The root
// reducer intercepts this; pair it with persistor.purge() to clear storage too.
export const resetStore = createAction("resetStore");
